import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-3 col-md-3"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "Select population loader profile:", -1)
const _hoisted_3 = ["value"]

import { useAgencyTypeStore } from "@/stores/agencyTypesStore";

import { computed, onMounted, ref, watch } from "vue";

import { usePopulationStore } from "@/stores/populationStore";
import { PopulationProfile } from "@/types";

export default /*#__PURE__*/_defineComponent({
  __name: 'PopulationUpload',
  setup(__props, { emit: __emit }) {

const emit = __emit;
const agencyTypeStore = useAgencyTypeStore();
agencyTypeStore.list();

const populationStore = usePopulationStore();
const profile = ref<PopulationProfile>();
const showProfiles = computed(() => populationStore.settings.length > 1);

onMounted(async () => {
    await populationStore.listSettings();
    profile.value = populationStore.settings[0];
});

watch(profile, (newValue, oldValue) => {
    
    if (showProfiles.value) {
        emit("update:modelValue", profile);
    }
});

return (_ctx: any,_cache: any) => {
  return (showProfiles.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _withDirectives(_createElementVNode("select", {
          class: "form-select",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((profile).value = $event)),
          "aria-label": "Select Profile"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(populationStore).settings, (item) => {
            return (_openBlock(), _createElementBlock("option", {
              value: item,
              key: item.ProfileName
            }, _toDisplayString(item.ProfileName), 9, _hoisted_3))
          }), 128))
        ], 512), [
          [_vModelSelect, profile.value]
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})